module.exports = __webpack_public_path__ + "static/media/ecec.72d954ab.png";